import { Controller } from '@hotwired/stimulus'

export default class DrawerController extends Controller {
  static values = { openOnConnect: Boolean }
  declare openOnConnectValue: boolean
  declare hasOpenOnConnectValue: boolean

  connect(): void {
    if (this.hasOpenOnConnectValue && this.openOnConnectValue) {
      this.open()
    }
  }

  open(event?: Event): void {
    if (event) {
      event.preventDefault()
    }
    if (window.eventHub) {
      window.eventHub.$emit('drawer:open', {
        direction: 'right',
        content: 'default',
      })
    }
  }

  close(event?: Event): void {
    if (event) {
      event.preventDefault()
    }
    if (window.eventHub) {
      window.eventHub.$emit('drawer:close', 'right')
    }
  }

  // This action should be attached to forms that need to close the drawer on success
  closeOnSuccess(event: CustomEvent): void {
    const detail = event.detail as { fetchResponse?: { succeeded: boolean } }
    if (detail.fetchResponse?.succeeded) {
      this.close()
    }
  }
}
